<div class="p-7 relative overflow-y-auto" style="max-height: 90vh">
  <div class="absolute right-0 top-0 p-2">
    <button mat-button (click)="close()">
      <fa-icon [icon]="faTimes" />
    </button>
  </div>

  <h1 class="text-center" i18n>Upgrade your subscription</h1>

  <div class="mt-4">
    @switch (data.reason) {
      @case (SubscriptionUpgradeReason.General) {
        <h4 class="text-center" i18n>Upgrade your subscription to get more value</h4>
      }
      @case (SubscriptionUpgradeReason.MaxKnowledgeBaseCountReached) {
        <h4 class="text-center" i18n>You've reached the maximum number of knowledge bases in your subscription. Upgrade
          to get more.</h4>
      }
      @case (SubscriptionUpgradeReason.MaxArticleCountReached) {
        <h4 class="text-center" i18n>You've reached the maximum number of articles in your subscription. Upgrade
          to get more.</h4>
      }
      @case (SubscriptionUpgradeReason.MaxKnowledgeBaseDomainCountReached) {
        <h4 class="text-center" i18n>You've reached the maximum number of custom domains per knowledge base in your
          subscription. Upgrade
          to get more.</h4>
      }
      @case (SubscriptionUpgradeReason.MissingFormNotificationsFeature) {
        <h4 class="text-center" i18n>Upgrade your subscription to receive form notifications.</h4>
      }
    }
  </div>

  <div class="mt-3">
    <app-pricing (subscriptionsChanged)="close()" />
  </div>
</div>
